/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable, TemplateRef } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { ExtendedRoute, ExtendedRoutes } from '@increff/commons';

import { environment } from 'src/environments/environment';
import { APP_ROUTES } from '../route-config';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    /**
     * For routes to be defined in the navbar
     */
    pageTitle: string;

    public pageHeaderSource = new BehaviorSubject<string>('');
    pageHeader = this.pageHeaderSource.asObservable();

    private routeTreeSource = new BehaviorSubject<ExtendedRoutes>([]);
    routeTree = this.routeTreeSource.asObservable();

    private parentChildrenMapSource = new BehaviorSubject<Record<string, any>>({});
    parentChildrenMap = this.parentChildrenMapSource.asObservable();

    private routeParentMap: any = {};

    pageHeaderExtraTemplateRef: TemplateRef<string> = null;

    constructor(
        private title: Title
    ) {
        const appRoutesTree = this.generateRoutes(APP_ROUTES);
        this.changeRouteTree(appRoutesTree);
        this.changeParentChildrenMap(this.routeParentMap);
    }

    makeSet(arr, key) {
        let idIndex; const hashMap = {};
        for (const obj of arr) {
            idIndex = `${obj}${key}`;
            hashMap[idIndex] = obj;
        }
        return hashMap;
    }

    removeElemArr(arr, elem) {
        for (const obj in arr)
            if (JSON.stringify(arr[obj]) === JSON.stringify(elem)) arr.splice(obj, 1);

        return arr;
    }

    private changeRouteTree(routeTree: ExtendedRoutes) {
        this.routeTreeSource.next(routeTree);
    }

    private changeParentChildrenMap(parentChildMap: any) {
        this.parentChildrenMapSource.next(parentChildMap);
    }

    private generateRoutes(list: any[], parentPath?: string) {
        return list.filter(x => (x?.path) && environment.sidebarExcludedRoutes.indexOf(x.path) === -1).map((obj) => {
            const navItem: ExtendedRoute = {
                name: obj?.name || obj?.title,
                title: obj?.title || obj.name,
                iconClass: obj.iconClass,
                baseUrl: parentPath ? `${parentPath}/${obj.path}` : `/${obj.path}`,
                hideRoute: obj?.hideRoute
            };
            if (obj['children']?.length)
                navItem['children'] = this.generateRoutes(obj['children'], navItem['baseUrl']);

            if(!navItem['children']?.length && !obj['hideSiblingRoute'])
                this.routeParentMap['dummyOuter'] ? this.routeParentMap['dummyOuter'].push(navItem) : this.routeParentMap['dummyOuter'] = [navItem];
            else
                this.routeParentMap[navItem['baseUrl']] = navItem['children'] || [] ;

            return navItem;
        });
    }

    setPageTitle(title: string) {
        this.pageTitle = title;
        this.title.setTitle(`Increff Account ${title? '- ' + title : ''}`);
    }
}
